class Cursor {
	constructor() {

		// Curseur principal
		this.mainFollower = document.querySelector('.main-follower');
		this.mainFollowerText = this.mainFollower.querySelector('.text');
		this.mainFollowerBall = this.mainFollower.querySelector('.ball');

		this.directions = ['top', 'right', 'bottom', 'left'];

		// animation du curseur
		this.mainFollowerIsTick = false;
		this.initMainFollower();

		// transformation du cursor
		this.initMainFollowerTransform();

		// apparition / disparition des textes du curseur
		this.initMainFollowerTextAppear();

		// apparition / disparition des SVG du curseur
		this.initMainFollowerSVGAppear();

		// animation des curseurs secondaires
		this.initSecondaryFollower();

	}

	initMainFollower() {

		gsap.set(this.mainFollower, {xPercent: -50, yPercent: -50});
		// gsap.set(this.mainFollowerHalo, {xPercent: -50, yPercent: -50});

		this.pos = {x: window.innerWidth / 2, y: window.innerHeight / 2};
		this.posHalo = {x: window.innerWidth / 2, y: window.innerHeight / 2};
		this.mouse = {
			x: this.pos.x,
			y: this.pos.y
		};
		let speed = 0.1;

		let fpms = 60 / 1000;

		this.xSet = gsap.quickSetter(this.mainFollower, "x", "px");
		this.ySet = gsap.quickSetter(this.mainFollower, "y", "px");

		// this.xSetHalo = gsap.quickSetter(this.mainFollowerHalo, "x", "px");
		// this.ySetHalo = gsap.quickSetter(this.mainFollowerHalo, "y", "px");

		this.boundEventHandler = this.moveMainFollower.bind(this);
		window.addEventListener("mousemove", this.boundEventHandler);

		gsap.ticker.add((time, deltaTime) => {

			let delta = deltaTime * fpms;
			let dt = 1.0 - Math.pow(1.0 - speed, delta);

			// this.posHalo.x += (this.mouse.x - this.posHalo.x);
			// this.posHalo.y += (this.mouse.y - this.posHalo.y);

			// this.xSetHalo(this.posHalo.x);
			// this.ySetHalo(this.posHalo.y);

			if( !this.mainFollowerIsTick ) {

				this.pos.x += (this.mouse.x - this.pos.x) * dt;
				this.pos.y += (this.mouse.y - this.pos.y) * dt;

				this.xSet(this.pos.x);
				this.ySet(this.pos.y);

			}
		});

		this.btnEffectHover = document.querySelectorAll(".btn");
		this.btnEffectHover.forEach( (btn) => {
			btn.addEventListener("mouseenter", () => {
				this.hitBtn(btn);
			});
			btn.addEventListener("mouseleave", () => {
				this.avoidBtn(btn);
			});
		});

	}

	moveMainFollower(e, x, y) {
		this.mouse.x = (x) ? x : e.x;
		this.mouse.y = (y) ? y : e.y;
	}

	hitBtn(el){
		this.mainFollowerIsTick = true;

		this.pos.x = el.getBoundingClientRect().left + el.offsetWidth / 2;
		this.pos.y = el.getBoundingClientRect().top + el.offsetHeight / 2;

		gsap.to( this.mainFollower,{
			x : this.pos.x - this.mainFollowerBall.offsetWidth / 2,
			y : this.pos.y - this.mainFollowerBall.offsetHeight / 2,
			duration : 0.5,
			immediateRender: true
		});
		this.mainFollower.classList.add('scale-approach');
	}

	avoidBtn(){
		this.mainFollowerIsTick = false;
		this.mainFollower.classList.remove('scale-approach');
	}

	initMainFollowerTransform() {

		let hoveredElements = document.querySelectorAll('[data-hover-cursor-effect]');
		hoveredElements.forEach((el) => {
			el.addEventListener('mouseenter', () => {
				this.mainFollower.classList.add(el.dataset.hoverCursorEffect);
			});
			el.addEventListener('mouseleave', () => {
				this.mainFollower.classList.remove(el.dataset.hoverCursorEffect);
			});
		});

	}

	initMainFollowerTextAppear() {

		let textRevealElements = document.querySelectorAll('[data-hover-cursor-text]');
		textRevealElements.forEach((el) => {
			el.addEventListener('mouseenter', () => {
				this.mainFollowerText.innerHTML = el.dataset.hoverCursorText;
				this.mainFollower.classList.add('text-reveal');
			});
			el.addEventListener('mouseleave', () => {
				this.mainFollower.classList.remove('text-reveal');
				this.mainFollowerText.innerHTML = "";
			});
		});

	}

	initMainFollowerSVGAppear() {

		let svgRevealElements = document.querySelectorAll('[data-hover-cursor-svg]');
		svgRevealElements.forEach((el) => {
			el.addEventListener('mouseenter', () => {
				this.mainFollower.classList.add('svg-reveal');
			});
			el.addEventListener('mouseleave', () => {
				this.mainFollower.classList.remove('svg-reveal');
			});
		});

	}

	initSecondaryFollower() {

		let secondaryFollower = document.querySelectorAll('[data-secondary-follower]');

		secondaryFollower.forEach((secondary) => {

			let followers = secondary.querySelectorAll('.secondary-follower');

			secondary.addEventListener('mouseenter', (e) => {
				followers.forEach((btn) => {
					btn.classList.add('reveal');
				});
			});

			secondary.addEventListener('mouseleave', (e) => {
				this.avoidBtn();
				followers.forEach((btn) => {
					btn.classList.remove('reveal');
				});
			});

			secondary.addEventListener('mousemove', (e) => {

				this.near = false;

				followers.forEach((btn, index) => {

                    let btnPosition = btn.getBoundingClientRect();

					let inner = btn.closest('.secondary-follower-container');
					let rect = inner.getBoundingClientRect();
					let w = inner.offsetWidth;
					let h = inner.offsetHeight;

					let relX = (e.clientX - ( rect.left - w/2 ) );
					let relY = (e.clientY - ( rect.top - h/2 ) ) ;

					gsap.to(btn, {
						x: relX,
						y: relY
					});

                    let x = (e.clientX - rect.left - (w / 2)) * (w > h ? (h / w) : 1);
                    let y = (e.clientY - rect.top - (h / 2)) * (h > w ? (w / h) : 1);
                    let d = Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;

                    let addX = 0;
                    let addY = 0;

                    let distanceFromLeft = this.distance(e.clientX, e.clientX, rect.left, rect.left);
                    let distanceFromRight = this.distance(e.clientX, e.clientX, rect.left + w, rect.left + w);
                    let distanceFromTop = this.distance(e.clientY, e.clientY, rect.top, rect.top);
                    let distanceFromBottom = this.distance(e.clientY, e.clientY, rect.top + h, rect.top + h);

                    let distance = [distanceFromTop, distanceFromRight, distanceFromBottom, distanceFromLeft];

                    switch (this.directions[d]) {
                        case 'top':
                            addY = 30;
                            break;
                        case 'bottom':
                            addY = -30;
                            break;
                        case 'left':
                            addX = 30;
                            break;
                        case 'right':
                            addX = -30;
                            break;
                    }

                    if( distance[d] < 30 || (  e.clientX > rect.left && e.clientX < rect.left + w && e.clientY > rect.top && e.clientY < rect.top + h )) {
                        this.near = true;
						this.hitBtn(inner);
                    }

				});

                if( !this.near && !this.mainFollowerIsTick ){
	                this.avoidBtn();
                }

			});
		});

	}

	distance(x1, y1, x2, y2) {
		let a = x1 - x2;
		let b = y1 - y2;
		return Math.hypot(a, b);
	}

}